import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Document from './../../../../../../components/document';
import { PERMISSIONS } from './../../../../../../components/document/types';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAdmin } from '../../../../../../reducers/onboarding';
import { updateUserDetails } from '../../../../../../reducers/identity';
import { CheckboxField } from '../../../../../../components/fields';
import messages from '../../../../../../text/messages';
import mixpanel from 'mixpanel-browser';
class InsuranceRequirementsStep extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            icSkipInsurance: false
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'InsuranceRequirementsStep' } });

        const { admin, client, getAdmin, contractor } = this.props;

        this.setState({ icSkipInsurance: contractor.ic_no_insurance || false });
        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submit(action) {
        const { role, updateUserDetails, contractor } = this.props;
        const { icSkipInsurance } = this.state;

        if (icSkipInsurance !== (contractor.ic_no_insurance || false)) {
            updateUserDetails(role, { ...contractor, ic_no_insurance: icSkipInsurance }, action);
        } else {
            action();
        }
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, client, admin, insuranceProvided } = this.props;
        const { icSkipInsurance } = this.state;

        const { ic_waive_insurance } = client.job_policies || {};
        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'icinsr.intro'}
                            defaultMessage={'{co} requires that all independent contractors carry insurance to the levels indicated below.'}
                            values={{ co: client.name }}
                            tagName={'h5'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <div className="row section">
                            <div className="col-xs-12">
                                <FormattedMessage id={'requiredCoverage'} defaultMessage={'Required coverage'} tagName={'h5'} />
                                <FormattedHTMLMessage
                                    id={'icinsr.levels'}
                                    defaultMessage={
                                        '<ul> <li>General liability coverage up to $2,000,000</li> <li>Errors & Omissions coverage up to $1,000,000</li> <li>Auto liability coverage up to $1,000,000</li> <li>Workers Compensation coverage up to $1,000,000</li> </ul>'
                                    }
                                    values={{ co: client.name }}
                                    tagName={'div'}
                                />
                            </div>
                        </div>
                        <div className="row section">
                            <div className="col-xs-12">
                                <FormattedMessage id={'proofOfInsurance'} defaultMessage={'Proof of Insurance'} tagName={'h5'} />
                                <FormattedMessage
                                    id={'icinsr.upload'}
                                    defaultMessage={
                                        'Please upload a proof of insurance certificate proving the required levels of coverage, and naming {admin} as an additional insured.'
                                    }
                                    values={{ admin: admin.name }}
                                    tagName={'p'}
                                />
                                <Document
                                    id={'onboardingICInsurance'}
                                    displayName={'Contractor proof of insurance'}
                                    docType={'insurance'}
                                    upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                                    view={{ showHeader: false, component: 'icon-download' }}
                                />
                            </div>
                            <div className="col-xs-12">
                                {ic_waive_insurance && (
                                    <Field
                                        name="icSkipInsurance"
                                        component={CheckboxField}
                                        checked={icSkipInsurance}
                                        onChange={e => {
                                            this.setState({ icSkipInsurance: e.target.checked });
                                        }}
                                        placeholder={messages.icNoInsurance}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-5">
                        <div className="row section">
                            <div className="col-xs-12">
                                <div className="col-xs-12 purchase-insurance-box">
                                    <FormattedMessage id={'needInsurance'} defaultMessage={'Need insurance?'} tagName={'h5'} />
                                    <FormattedMessage
                                        id={'icinsr.buy'}
                                        defaultMessage={`If you don't yet have appropriate insurance, we recommend {insr} - they offer business insurance policies designed for contractors and gig workers.`}
                                        values={{ admin: admin.name, insr: 'Bunker' }}
                                    />

                                    <div className="purchase-link">
                                        <a href="https://www.buildbunker.com/" target="_blank" rel="noopener noreferrer">
                                            <FormattedMessage id={'purchaseInsurance'} defaultMessage={'PURCHASE INSURANCE'} />
                                        </a>
                                    </div>
                                    <div>
                                        <FormattedMessage
                                            id={'icinsr.finePrint'}
                                            defaultMessage={
                                                '{co} and {admin} are not affiliated with {insr}. You are responsible for any risk and expense of obtaining insurance coverage through {insr}.'
                                            }
                                            values={{ co: client.name, admin: admin.name, insr: 'Bunker' }}
                                            tagName={'small'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <WizardButtons disabled={submitting || (!insuranceProvided && !icSkipInsurance)} back={{ action: back }} />
            </form>
        );
    }
}

InsuranceRequirementsStep = reduxForm(formSettings)(InsuranceRequirementsStep);

const mapStateToProps = state => {
    let insuranceDocs = state.documents.onboardingICInsurance;
    return {
        role: state.identity.role,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        contractor: state.identity.details,
        insuranceProvided: insuranceDocs && insuranceDocs.list && insuranceDocs.list.length > 0
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            updateUserDetails: updateUserDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceRequirementsStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/insuranceRequirements.jsx